<template>
  <footer class="bg-white text-center text-lg-start">
    <div class="container-fluid border d-md-flex p-5">
      <div class="col-lg-6 col-md-6 col-sm-12 p-5">
        <div class="navbar-brand" to="/">
          <img :src="footer.image_slogan" alt="Logo" style="width: 400px" class="img-fluid" />
          <div class="p-3">
            <a :href="instagramUrl" target="_blank">
              <i class="fa fas fa-brands fa-instagram fa-3x me-5" style="color: #000000;"></i></a>
            <a :href="facebookUrl" target="_blank">
              <i class="fa fas fa-brands fa-facebook-square fa-3x" style="color: #000000;"></i></a>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 p-5">
        <h3 style="font-weight:bolder">Download Our App</h3>
        <a :href="footer.apple_store" target="_blank">
          <img :src="footer.image_app_store" alt="" class="img-fluid" style="width: 300px; margin-right: 15px"></a>
        <a :href="footer.google_store" target="_blank">
          <img :src="footer.image_google_play" alt="" class="img-fluid" style="width: 300px"></a>
        <div class="mt-5">
          <p>{{ footer.text }}</p>
        </div>
      </div>
    </div>
    <div class="bg-black py-3">
      <div class="d-flex justify-content-center my-4 gap-5">
        <a :href="instagramUrl" target="_blank">
          <i class="fa fas fa-brands fa-instagram fa-2x mcd-primary"></i>
        </a>
        <a :href="facebookUrl" target="_blank">
          <i class="fa fas fa-brands fa-facebook-square fa-2x mcd-primary"></i>
        </a>
        <a href="https://goo.gl/maps/AEXe8U43wWpGevxN6" target="_blank">
          <i class="fa fas fa-map-marker fa-2x mcd-primary"></i>
        </a>
      </div>
      <div class="row justify-content-center">
        <div v-for="(item, index) in menus" :key="index" class="col-auto">
          <router-link class="font-white no-underline" :to="redirect(item)">{{ item.name }}</router-link>
          <span v-if="index !== menus.length - 1" class="font-white">&nbsp; &nbsp; | </span>
        </div>
      </div>

      <div class="text-justify font-size-sm">
        <div class="container">
          <div class="card bg-black">
            <div class="card-body text-center" style="padding-left: 10%">
              <p>{{ footer.copyright }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

  
<script>
import axios from "axios";

export default {
  name: "FooterComponent",

  data() {
    return {
      showTopBar: true,
      menus: [],
      footer: [],
      social_media: [],
    };
  },

  methods: {
    redirect(item) {
      let redirectTo = "#";

      if (item.slug == "home-view") {
        redirectTo = "/";
      } else if (item.path == null) {
        redirectTo = "#";
      } else {
        redirectTo = item.path;
      }

      return redirectTo;
    },
    loadFooter() {
      axios
        .get("/footers")
        .then((response) => {
          this.footer = response.data.data;
          this.setSocialMediaUrls();
        })
        .catch((error) => {
          console.error("Error fetching footers:", error);
        });
    },
    setSocialMediaUrls() {
      if (this.footer) {
        // Find the URLs for Instagram and Facebook in the social_media array
        const instagramData = this.footer.social_media.find(item => item.name === 'Instagram URL');
        const facebookData = this.footer.social_media.find(item => item.name === 'Facebook URL');

        // Set the URLs to the data properties for Instagram and Facebook
        this.instagramUrl = instagramData ? instagramData.url : null;
        this.facebookUrl = facebookData ? facebookData.url : null;
      }
    }
  },

  mounted() {
    axios.get("/headers/4/view").then((response) => {
      this.menus = response.data.data.menus;
    });
    this.loadFooter();
  },
};
</script>

<style scoped>
@media only screen and (max-width: 1024px) and (min-height: 844px) {
  .image-footer {
    position: relative;
    z-index: 1; /* Ensure the image is on top */
  }
}
</style>